module.exports = __webpack_public_path__ + "img/storeBgc.60ef36ff.png";